export const INVOICING_EN = {
    // ── payment terms (#80) ──
    'nav.invoicing.payment_terms': 'Payment terms',
    'screen.invoicing.payment_terms.title': 'Payment terms',
    'screen.invoicing.payment_terms.lede': 'When a document falls due: so many days after its issue day, or from the end of its month.',
    'screen.invoicing.payment_terms.column.code': 'Code',
    'screen.invoicing.payment_terms.column.name_ar': 'Name (Arabic)',
    'screen.invoicing.payment_terms.column.name_en': 'Name (English)',
    'screen.invoicing.payment_terms.column.basis': 'Counted from',
    'screen.invoicing.payment_terms.column.days': 'Days',
    'screen.invoicing.payment_terms.column.documents': 'Documents',
    'screen.invoicing.payment_terms.column.state': 'State',
    'screen.invoicing.payment_terms.column.active': 'Active',
    'screen.invoicing.payment_terms.field.code.help': 'Letters and digits, as it is known: NET30.',
    'screen.invoicing.payment_terms.field.days.help': '0 from the issue day is due on receipt; 0 from the end of the month is due that day.',
    'screen.invoicing.payment_terms.field.days.edit_help': 'A document already issued keeps its due day; a draft is counted again when saved.',
    'screen.invoicing.payment_terms.action.import_pack': 'Import common terms',
    'screen.invoicing.payment_terms.action.create': 'New payment term',
    'screen.invoicing.payment_terms.action.edit': 'Edit',
    'screen.invoicing.payment_terms.action.retire': 'Retire',
    'value.basis.days': 'The issue day',
    'value.basis.end_of_month': 'The end of the issue month',
    'value.state.active': 'Active',
    'value.state.retired': 'Retired',
    'invoicing.party.terms.title': 'Terms',
    'invoicing.party.terms.col.payment_term': 'Payment term',
    'invoicing.party.terms.col.credit_limit': 'Credit limit',
    'invoicing.party.terms.col.credit_available': 'Left of the limit',
    'invoicing.party.terms.action.set': 'Set terms',
    'invoicing.party.terms.field.payment_term.help': "What this party's new invoices and bills start on. It can still be changed on each document.",
    'invoicing.party.terms.field.credit_limit.help': 'Empty: no limit. The invoice editor warns when a new invoice would take the party over it; it does not refuse.',
    'screen.invoicing.documents.column.due_on': 'Due',
    'screen.invoicing.documents.column.due_state': 'Payment',
    'screen.invoicing.documents.column.days_overdue': 'Days overdue',
    'screen.invoicing.documents.column.payment_term_id': 'Payment term',
    'screen.invoicing.documents.stat.overdue': 'Overdue',
    'screen.invoicing.vendor_bills.column.due_on': 'Due',
    'screen.invoicing.vendor_bills.column.due_state': 'Payment',
    'screen.invoicing.vendor_bills.column.days_overdue': 'Days overdue',
    'screen.invoicing.vendor_bills.column.payment_term_id': 'Payment term',
    'screen.invoicing.vendor_bills.stat.overdue': 'Overdue',
    'screen.invoicing.vendor_bills.stat.due_week': 'Due this week',
    'screen.invoicing.vendor_bills.column.due_this_week': 'Due this week',
    'value.due_state.overdue': 'Overdue',
    'value.due_state.not_due': 'Not due yet',
    'value.due_state.settled': 'Settled',
    'screen.invoicing.aging_ar.lede': 'Open documents aged by the days past their due day; one with no due day is aged from its issue day.',
    'screen.invoicing.aging_ap.lede': 'Open documents aged by the days past their due day; one with no due day is aged from its issue day.',
    'screen.invoicing.aging_ar.column.due_on': 'Due',
    'screen.invoicing.aging_ap.column.due_on': 'Due',
    'value.bucket.not_due': 'Not due yet',
    'value.bucket.1_30': '1–30 days',
    'editor.terms.term': 'Payment term',
    'editor.terms.termHint': 'Or leave it empty and enter a due date.',
    'editor.terms.none': 'No term: a due date',
    'editor.terms.dueCounted': 'Counted from the term; issued on another day, it moves with it.',
    'editor.terms.dueAtIssue': 'Counted at issue',
    'editor.terms.overLimit': 'With this invoice the customer would owe {owed} SAR, over their credit limit of {limit} SAR. It can still be issued.',
    'editor.choices.terms': 'the payment terms',
    'change.field.payment_term.basis': 'Counted from',
    'change.field.party_terms.party_id': 'Party',
    'change.field.party_terms.payment_term_id': 'Payment term',
    'change.field.party_terms.credit_limit': 'Credit limit',
    'change.field.party_terms.updated_by': 'Set by',
    'screen.invoicing.credit_note_new.title': 'Credit note',
    'screen.invoicing.credit_note_new.lede': "Takes back all or part of an issued invoice. Its lines start at what is left of each line of the invoice; reduce them for a partial credit. The reason is one of the authority's.",
    'screen.invoicing.debit_note_new.title': 'Debit note',
    'screen.invoicing.debit_note_new.lede': "Adds to an issued invoice what it charged too little: its lines start from the invoice's, each priced at the amount it adds. The reason is one of the authority's.",
    'screen.invoicing.documents.action.debit': 'Debit note',
    'screen.invoicing.documents.column.can_debit': 'Can debit',
    'editor.note.noOriginal': 'The invoice this note is for could not be read.',
    'editor.note.notPosted': 'Only an issued customer invoice takes a credit or debit note.',
    'editor.note.needReason': 'a reason',
    'editor.note.creditOf': "Credits invoice {number} of {date}: total {total} SAR, {left} SAR still creditable. The customer and their address are the invoice's and do not change here.",
    'editor.note.debitOf': "Adds to invoice {number} of {date}: total {total} SAR. The customer and their address are the invoice's and do not change here.",
    'editor.note.reason': 'Reason',
    'editor.note.chooseReason': 'Choose the reason',
    'editor.note.reasonText': 'The reason, in words',
    'editor.note.title.credit_note': 'Credit note',
    'editor.note.title.debit_note': 'Debit note',
    'editor.note.left': 'Left on the invoice',
    'editor.note.newCredit': 'Credit note',
    'editor.note.newDebit': 'Debit note',
    'editor.note.issued.credit_note': 'Credit note {id} issued.',
    'editor.note.issued.debit_note': 'Debit note {id} issued.',
    'editor.draft.finalBill': 'This bill is {state}. An issued bill is not edited: what it says is what the vendor issued.',
    'change.field.document.reason_text': 'Reason, in words',
    'change.field.document.original_line_no': 'Line of the invoice',
    "editor.totals.pricesIncludeVat": "Prices include VAT",
    "editor.totals.documentDiscount": "Document discount",
    "editor.totals.documentDiscountHint": "On the whole document, before VAT; shared across the lines by their amount.",
    "editor.totals.documentDiscountHintVat": "On the whole document, VAT included like the prices; shared across the lines by their amount.",
    "editor.totals.lines": "Lines, before VAT",
    "editor.totals.linesWithVat": "Lines, VAT included",
    "editor.totals.rate": "{code} {rate}%",
    "editor.totals.noTax": "No tax code",
    "editor.totals.base": "Taxable",
    "editor.totals.tax": "VAT",
    "editor.totals.total": "Total",
    "editor.totals.currency": "SAR",
    "nav.invoicing.settings": "Invoicing settings",
    "screen.invoicing.settings.title": "Invoicing settings",
    'screen.invoicing.settings.lede': 'Whether prices include VAT unless a document says otherwise, the account a discount posts to, and the largest discount given without «give any discount».',
    "screen.invoicing.settings.column.prices_basis": "Prices",
    "screen.invoicing.settings.column.sales_discount_account": "Discount account",
    "screen.invoicing.settings.column.max_line_discount_pct": "Largest line discount %",
    "screen.invoicing.settings.column.max_document_discount_pct": "Largest document discount %",
    "screen.invoicing.settings.column.updated_by": "Set by",
    "screen.invoicing.settings.column.updated_at": "Updated",
    "screen.invoicing.settings.action.set": "Change settings",
    "screen.invoicing.settings.field.prices_include_vat": "Prices are typed",
    "screen.invoicing.settings.field.prices_include_vat.help": "The default for a new document; each document can say otherwise.",
    "screen.invoicing.settings.field.sales_discount_account.help": "Where a discount on a whole sales document posts. A document with one cannot be issued without it.",
    "screen.invoicing.settings.field.max_line.help": "Of the line’s quantity × price. Empty: no limit.",
    "screen.invoicing.settings.field.max_document.help": "Of what the lines come to. Empty: no limit. Whoever holds «give any discount» is not held to either.",
    "value.prices_basis.exclusive": "Without VAT",
    "value.prices_basis.inclusive": "With VAT in them",
    "change.field.document.prices_include_vat": "Prices include VAT",
    "change.field.document.document_discount": "Document discount",
    "change.field.invoicing_settings.prices_include_vat": "Prices include VAT",
    "change.field.invoicing_settings.sales_discount_account_id": "Discount account",
    "change.field.invoicing_settings.max_line_discount_pct": "Largest line discount %",
    "change.field.invoicing_settings.max_document_discount_pct": "Largest document discount %",
    "change.field.invoicing_settings.updated_by": "Set by",
    // ── list pages: what an empty list means (list-standard §11, R6) ──
    'screen.invoicing.bank_reconciliation.empty': 'No bank statements imported yet',
    'screen.invoicing.bank_reconciliation.empty.description': 'Import a statement to match its lines to the open bank items.',
    'screen.invoicing.documents.empty': 'No invoices yet',
    'screen.invoicing.documents.empty.description': 'Every invoice, credit note and debit note appears here with its customer, due day and total.',
    'screen.invoicing.export_batches.empty': 'No exports yet',
    'screen.invoicing.export_batches.empty.description': 'Each export holds one period\'s entries for the external system, and the same scope is never exported twice.',
    'screen.invoicing.payments.empty': 'No payments recorded yet',
    'screen.invoicing.payments.empty.description': 'Every payment received or made appears here with its party, amount and what is left to allocate.',
    'screen.invoicing.vendor_bills.empty': 'No vendor bills yet',
    'screen.invoicing.vendor_bills.empty.description': 'Every bill from a supplier appears here with its due day and what is still open on it.',
    'screen.invoicing.payment_terms.empty': 'No payment terms yet',
    'screen.invoicing.payment_terms.empty.description': 'A term sets when a document falls due; without one, a document is due on the day it is issued.',
};
export const INVOICING_AR = {
    // ── آجال السداد (#80) ──
    'nav.invoicing.payment_terms': 'آجال السداد',
    'screen.invoicing.payment_terms.title': 'آجال السداد',
    'screen.invoicing.payment_terms.lede': 'متى يستحق المستند: بعد عدد من الأيام من تاريخ إصداره، أو من نهاية شهره.',
    'screen.invoicing.payment_terms.column.code': 'الرمز',
    'screen.invoicing.payment_terms.column.name_ar': 'الاسم (عربي)',
    'screen.invoicing.payment_terms.column.name_en': 'الاسم (إنجليزي)',
    'screen.invoicing.payment_terms.column.basis': 'يُحسب من',
    'screen.invoicing.payment_terms.column.days': 'الأيام',
    'screen.invoicing.payment_terms.column.documents': 'المستندات',
    'screen.invoicing.payment_terms.column.state': 'الحالة',
    'screen.invoicing.payment_terms.column.active': 'فعّال',
    'screen.invoicing.payment_terms.field.code.help': 'حروف وأرقام كما يُعرف به: NET30.',
    'screen.invoicing.payment_terms.field.days.help': 'صفر من يوم الإصدار يعني الدفع عند الاستلام؛ وصفر من نهاية الشهر يعني الاستحقاق آخر يوم فيه.',
    'screen.invoicing.payment_terms.field.days.edit_help': 'المستند الصادر يحتفظ بتاريخ استحقاقه؛ والمسودة يُعاد حسابها عند حفظها.',
    'screen.invoicing.payment_terms.action.import_pack': 'استيراد الآجال الشائعة',
    'screen.invoicing.payment_terms.action.create': 'أجل سداد جديد',
    'screen.invoicing.payment_terms.action.edit': 'تعديل',
    'screen.invoicing.payment_terms.action.retire': 'إيقاف',
    'value.basis.days': 'يوم الإصدار',
    'value.basis.end_of_month': 'نهاية شهر الإصدار',
    'value.state.active': 'فعّال',
    'value.state.retired': 'موقوف',
    'invoicing.party.terms.title': 'الشروط',
    'invoicing.party.terms.col.payment_term': 'أجل السداد',
    'invoicing.party.terms.col.credit_limit': 'حد الائتمان',
    'invoicing.party.terms.col.credit_available': 'المتبقي من الحد',
    'invoicing.party.terms.action.set': 'ضبط الشروط',
    'invoicing.party.terms.field.payment_term.help': 'الأجل الذي تبدأ به فواتير هذا الطرف الجديدة، ويبقى قابلاً للتغيير في كل مستند.',
    'invoicing.party.terms.field.credit_limit.help': 'فارغ: بلا حد. محرّر الفاتورة ينبّه حين تتجاوز فاتورة جديدة الحد، ولا يرفضها.',
    'screen.invoicing.documents.column.due_on': 'الاستحقاق',
    'screen.invoicing.documents.column.due_state': 'السداد',
    'screen.invoicing.documents.column.days_overdue': 'أيام التأخر',
    'screen.invoicing.documents.column.payment_term_id': 'أجل السداد',
    'screen.invoicing.documents.stat.overdue': 'متأخرة',
    'screen.invoicing.vendor_bills.column.due_on': 'الاستحقاق',
    'screen.invoicing.vendor_bills.column.due_state': 'السداد',
    'screen.invoicing.vendor_bills.column.days_overdue': 'أيام التأخر',
    'screen.invoicing.vendor_bills.column.payment_term_id': 'أجل السداد',
    'screen.invoicing.vendor_bills.stat.overdue': 'متأخرة',
    'screen.invoicing.vendor_bills.stat.due_week': 'مستحقّ هذا الأسبوع',
    'screen.invoicing.vendor_bills.column.due_this_week': 'مستحقّ هذا الأسبوع',
    'value.due_state.overdue': 'متأخرة',
    'value.due_state.not_due': 'لم تستحق بعد',
    'value.due_state.settled': 'مسدّدة',
    'screen.invoicing.aging_ar.lede': 'المستندات المفتوحة مُعمَّرةً بعدد الأيام بعد تاريخ استحقاقها، وما لا تاريخ استحقاق له يُعمَّر من تاريخ إصداره.',
    'screen.invoicing.aging_ap.lede': 'المستندات المفتوحة مُعمَّرةً بعدد الأيام بعد تاريخ استحقاقها، وما لا تاريخ استحقاق له يُعمَّر من تاريخ إصداره.',
    'screen.invoicing.aging_ar.column.due_on': 'الاستحقاق',
    'screen.invoicing.aging_ap.column.due_on': 'الاستحقاق',
    'value.bucket.not_due': 'لم تستحق بعد',
    'value.bucket.1_30': '1–30 يوماً',
    'editor.terms.term': 'أجل السداد',
    'editor.terms.termHint': 'أو اتركه فارغاً وأدخل تاريخ استحقاق.',
    'editor.terms.none': 'بلا أجل: تاريخ استحقاق',
    'editor.terms.dueCounted': 'محسوب من الأجل؛ إن صدرت في يوم آخر تحرّك معه.',
    'editor.terms.dueAtIssue': 'يُحسب عند الإصدار',
    'editor.terms.overLimit': 'بهذه الفاتورة يصبح على العميل {owed} ر.س، فوق حد ائتمانه البالغ {limit} ر.س. يمكن إصدارها مع ذلك.',
    'editor.choices.terms': 'آجال السداد',
    'change.field.payment_term.basis': 'يُحسب من',
    'change.field.party_terms.party_id': 'الطرف',
    'change.field.party_terms.payment_term_id': 'أجل السداد',
    'change.field.party_terms.credit_limit': 'حد الائتمان',
    'change.field.party_terms.updated_by': 'ضبطه',
    'screen.invoicing.credit_note_new.title': 'إشعار دائن',
    'screen.invoicing.credit_note_new.lede': 'يستردّ كل الفاتورة الصادرة أو جزءاً منها. تبدأ سطوره بالمتبقي من كل سطر في الفاتورة؛ أنقصها لإشعار جزئي. والسبب من أسباب الهيئة.',
    'screen.invoicing.debit_note_new.title': 'إشعار مدين',
    'screen.invoicing.debit_note_new.lede': 'يضيف إلى الفاتورة الصادرة ما نقص منها: تبدأ سطوره من سطور الفاتورة، ويُسعَّر كل سطر بالمبلغ الذي يضيفه. والسبب من أسباب الهيئة.',
    'screen.invoicing.documents.action.debit': 'إشعار مدين',
    'screen.invoicing.documents.column.can_debit': 'يقبل إشعاراً مديناً',
    'editor.note.noOriginal': 'تعذّرت قراءة الفاتورة التي يخصّها هذا الإشعار.',
    'editor.note.notPosted': 'لا يُصدر إشعار دائن أو مدين إلا على فاتورة عميل صادرة.',
    'editor.note.needReason': 'السبب',
    'editor.note.creditOf': 'يستردّ من الفاتورة {number} بتاريخ {date}: إجماليها {total} ر.س، والمتبقي القابل للاسترداد {left} ر.س. العميل وعنوانه كما في الفاتورة ولا يتغيّران هنا.',
    'editor.note.debitOf': 'يضيف إلى الفاتورة {number} بتاريخ {date}: إجماليها {total} ر.س. العميل وعنوانه كما في الفاتورة ولا يتغيّران هنا.',
    'editor.note.reason': 'السبب',
    'editor.note.chooseReason': 'اختر السبب',
    'editor.note.reasonText': 'السبب بالكلمات',
    'editor.note.title.credit_note': 'إشعار دائن',
    'editor.note.title.debit_note': 'إشعار مدين',
    'editor.note.left': 'المتبقي في الفاتورة',
    'editor.note.newCredit': 'إشعار دائن',
    'editor.note.newDebit': 'إشعار مدين',
    'editor.note.issued.credit_note': 'صدر الإشعار الدائن {id}.',
    'editor.note.issued.debit_note': 'صدر الإشعار المدين {id}.',
    'editor.draft.finalBill': 'هذه الفاتورة {state}. فاتورة المشتريات الصادرة لا تُعدَّل: ما فيها هو ما أصدره المورّد.',
    'change.field.document.reason_text': 'السبب بالكلمات',
    'change.field.document.original_line_no': 'سطر الفاتورة',
    "editor.totals.pricesIncludeVat": "الأسعار شاملة الضريبة",
    "editor.totals.documentDiscount": "خصم على المستند",
    "editor.totals.documentDiscountHint": "على المستند كله قبل الضريبة، ويُوزَّع على الأسطر بحسب مبالغها.",
    "editor.totals.documentDiscountHintVat": "على المستند كله شاملاً الضريبة كالأسعار، ويُوزَّع على الأسطر بحسب مبالغها.",
    "editor.totals.lines": "الأسطر قبل الضريبة",
    "editor.totals.linesWithVat": "الأسطر شاملة الضريبة",
    "editor.totals.rate": "{code} {rate}٪",
    "editor.totals.noTax": "بلا رمز ضريبة",
    "editor.totals.base": "الخاضع",
    "editor.totals.tax": "الضريبة",
    "editor.totals.total": "الإجمالي",
    "editor.totals.currency": "ر.س",
    "nav.invoicing.settings": "إعدادات الفوترة",
    "screen.invoicing.settings.title": "إعدادات الفوترة",
    'screen.invoicing.settings.lede': 'هل تشمل الأسعار الضريبة ما لم يقل المستند غير ذلك، والحساب الذي يُرحَّل إليه خصم المستند، وأكبر خصم يمنحه من لا يملك «منح أي خصم».',
    "screen.invoicing.settings.column.prices_basis": "الأسعار",
    "screen.invoicing.settings.column.sales_discount_account": "حساب الخصم",
    "screen.invoicing.settings.column.max_line_discount_pct": "أكبر خصم على السطر ٪",
    "screen.invoicing.settings.column.max_document_discount_pct": "أكبر خصم على المستند ٪",
    "screen.invoicing.settings.column.updated_by": "ضبطه",
    "screen.invoicing.settings.column.updated_at": "آخر تحديث",
    "screen.invoicing.settings.action.set": "تغيير الإعدادات",
    "screen.invoicing.settings.field.prices_include_vat": "تُكتب الأسعار",
    "screen.invoicing.settings.field.prices_include_vat.help": "الافتراضي للمستند الجديد، ولكل مستند أن يقول غير ذلك.",
    "screen.invoicing.settings.field.sales_discount_account.help": "حيث يُرحَّل الخصم على مستند مبيعات كامل. لا يصدر مستند فيه خصم بدونه.",
    "screen.invoicing.settings.field.max_line.help": "من الكمية × السعر في السطر. فارغ: بلا حد.",
    "screen.invoicing.settings.field.max_document.help": "مما تبلغه الأسطر. فارغ: بلا حد. ومن يملك «منح أي خصم» لا يتقيّد بأيّ منهما.",
    "value.prices_basis.exclusive": "غير شاملة الضريبة",
    "value.prices_basis.inclusive": "شاملة الضريبة",
    "change.field.document.prices_include_vat": "الأسعار شاملة الضريبة",
    "change.field.document.document_discount": "خصم على المستند",
    "change.field.invoicing_settings.prices_include_vat": "الأسعار شاملة الضريبة",
    "change.field.invoicing_settings.sales_discount_account_id": "حساب الخصم",
    "change.field.invoicing_settings.max_line_discount_pct": "أكبر خصم على السطر ٪",
    "change.field.invoicing_settings.max_document_discount_pct": "أكبر خصم على المستند ٪",
    "change.field.invoicing_settings.updated_by": "ضبطه",
    // ── list pages: what an empty list means (list-standard §11, R6) ──
    'screen.invoicing.bank_reconciliation.empty': 'لم يُستورد كشف بنك بعد',
    'screen.invoicing.bank_reconciliation.empty.description': 'استورد كشفًا لتطابق أسطره مع بنود البنك المفتوحة.',
    'screen.invoicing.documents.empty': 'لا فواتير بعد',
    'screen.invoicing.documents.empty.description': 'كل فاتورة وإشعار دائن ومدين يظهر هنا بعميله وتاريخ استحقاقه وإجماليه.',
    'screen.invoicing.export_batches.empty': 'لا تصديرات بعد',
    'screen.invoicing.export_batches.empty.description': 'كل تصدير يحمل قيود فترة واحدة للنظام الخارجي، ولا يُصدَّر النطاق نفسه مرتين.',
    'screen.invoicing.payments.empty': 'لا دفعات مسجّلة بعد',
    'screen.invoicing.payments.empty.description': 'كل سند قبض أو صرف يظهر هنا بطرفه ومبلغه وما بقي منه دون تخصيص.',
    'screen.invoicing.vendor_bills.empty': 'لا فواتير مشتريات بعد',
    'screen.invoicing.vendor_bills.empty.description': 'كل فاتورة من مورّد تظهر هنا بتاريخ استحقاقها وما بقي مفتوحًا منها.',
    'screen.invoicing.payment_terms.empty': 'لا آجال سداد بعد',
    'screen.invoicing.payment_terms.empty.description': 'الأجل يحدّد متى يستحق المستند، ومن دونه يستحق المستند يوم إصداره.',
};
//# sourceMappingURL=i18n-invoicing.js.map